export class EntriesHttp {
    /**
     * Gets entries for tech
     * @param id
     * @return {Promise<AxiosResponse<any>>}
     */
    static async fetchEntries(id) {
        try {
            return await window.axios.get(`entries/${id}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Update an entry
     * @param entry
     * @return {Promise<AxiosResponse<any>>}
     */
    static async updateEntry(entry) {
        try {
            return await window.axios.put(`entries/`, entry);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Delete an entry
     * @param id
     * @return {Promise<AxiosResponse<any>>}
     */
    static async deleteEntry(id) {
        try {
            return await window.axios.delete(`entries/${id}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Creates an entry
     * @param entry
     * @return {Promise<AxiosResponse<any>>}
     */
    static async createEntry(entry) {
        try {
            return await window.axios.post(`entries/`, entry);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
